import * as ko from 'knockout';

import { BaseTraitActionViewModel } from './base_trait_action';
import { TraitAction } from '../../models/trait_action';
import { TRAIT_ACTION_TYPES, TraitActionOptionsData } from '../../api/trait_actions';
export class ScanCodeViewModel extends BaseTraitActionViewModel {
  protected updateIsEnabled(options: TraitActionOptionsData) {
    const hasTextSources = options.sources.some((s) => s.type === 'string');
    const hasChoiceTargets = options.targets.some((t) => t.type === 'choice');
    this.isEnabled(hasTextSources && hasChoiceTargets);
  }

  protected onTraitOptionsRefreshed(traitAction: TraitAction, options: TraitActionOptionsData) {
    const validSourceIds = this.getAvailableSourceOptions(traitAction).map((o) => o.id);
    if (traitAction.sourceTraitId() && !validSourceIds.includes(traitAction.sourceTraitId())) {
      traitAction.sourceTraitId(undefined);
    }

    const validTargetIds = this.getAvailableTargetOptions(traitAction).map((o) => o.id);
    if (traitAction.targetTraitId() && !validTargetIds.includes(traitAction.targetTraitId())) {
      traitAction.targetTraitId(undefined);
    }
  }

  protected onAddNewAction(newTraitAction: TraitAction) {
    newTraitAction.actionType(TRAIT_ACTION_TYPES.SET_VALUE);
  }

  getAvailableActionTypes(traitAction: TraitAction) {
    return traitAction.getActionTypeOptions().filter((o) => {
      return o.value === TRAIT_ACTION_TYPES.SET_VALUE || o.value === TRAIT_ACTION_TYPES.PLAY_SOUND;
    });
  }

  getAvailableSourceOptions(traitAction: TraitAction) {
    return traitAction.getSourceOptions().filter((o) => o.type === 'string');
  }

  getAvailableTargetOptions(traitAction: TraitAction) {
    return traitAction.getTargetOptions().filter((o) => o.type === 'choice');
  }
}

ko.components.register('scan-code', {
  viewModel: ScanCodeViewModel,
  template: require('raw-loader!../../../templates/components/trial_wizard/scan_code.html').default,
});
